import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PATIENT_EXCLUDED_FILTERS_FROM_POPOVER_VIEW, usePatientsQuery } from '@/services/patients'
import { columns, PATIENT_FILTER_ONLY_COLUMNS } from './columns'
import DataGridTable from '@/components/shared/DataGridTable'

export default function PatientsPage() {
  const navigate = useNavigate()

  const { patients, count, hasNextPage, isLoading, isFetching, dataGridConfig } = usePatientsQuery({
    tableId: 'patients'
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        Patients
      </Typography>

      <DataGridTable
        {...dataGridConfig}
        rows={patients}
        excludedFilters={PATIENT_EXCLUDED_FILTERS_FROM_POPOVER_VIEW}
        filterOnlyColumns={PATIENT_FILTER_ONLY_COLUMNS}
        columns={columns}
        rowCount={count}
        paginationMeta={{ hasNextPage }}
        loading={isLoading || isFetching}
        showQuickFilter={false}
        onRowClick={params =>
          navigate(`/patients/${params.id}`, {
            state: { backLabel: 'Back to Patients', fallbackPath: '/patients' }
          })
        }
      />
    </Box>
  )
}
